import { ThemeProvider } from '@material-ui/core/styles'
import ActivityStage from 'components/activity-plans/stage'
import { SnackbarProvider } from 'notistack'
import ABTestPage from 'pages/ab'
import AcceptInvitation from 'pages/accept-invitation'
import AssumeUserPage from 'pages/assume-user'
import BookingConfirmationPage from 'pages/booking-confirmation'
import LogoutPage from 'pages/logout'
import SinglePlansPublicPage from 'pages/pga-coach/activity-plans/stage/activity-plans/SingleActivityPlanPublic'
import CreateEvent from 'pages/pga-coach/bookings/events/new'
import CreateProfile from 'pages/pga-coach/profile/new'
import PublicActivityPlansPage from 'pages/public-activity-plans'
import ScheduleSessionFlow from 'pages/schedule'
import CoachingRequestForm from 'pages/schedule/CoachingRequestForm'
import WelcomePage from 'pages/welcome'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import FamilyCupCaptainRoutes from 'routes/family-cup-captain-routes'
import FamilyCupInvitationRoutes from 'routes/family-cup-invitation-routes'
import FamilyCupMarketingRoutes from 'routes/family-cup-marketing-routes'
import FamilyCupRegistrationRoutes from 'routes/family-cup-registration-routes'
import JuniorLeagueMarketingRoutes from 'routes/junior-league-marketing-routes'
import JuniorLeagueRegistrationRoutes from 'routes/junior-league-registration-routes'
import JuniorLeagueRoutes from 'routes/junior-league-routes'
import JuniorLeagueSignupRoutes from 'routes/junior-league-signup-routes'
import ThingsToDoRoutes from 'routes/things-to-do-routes'
import { flags, useFeatureFlags } from '../lib/feature-flags'
import themes, { extendTheme } from '../themes'
import AcademyRoutes from './academy-routes'
import AccountRoutes from './account-routes'
import AdminRoutes from './admin-routes'
import ClubRoutes from './club-routes'
import FamilyCupRoutes from './family-cup-routes'
import FamilyCupSignupRoutes from './fc-signup-routes'
import JuniorLeagueManagerRoutes from './junior-league-manager-routes'
import PgaCoachRoutes from './pga-coach-routes'
import Ideas from '../pages/ideas'

function Routes() {
  const [
    isLeadIntakeFormEnabled,
    isIdeasPageEnabled,
    isCoachOfferingsRefreshEnabled,
    FGRActive,
  ] = useFeatureFlags([
    flags.FLAG_FEAT_LEAD_INTAKE_STEPPER_FORM,
    flags.FLAG_FEAT_IDEAS_PAGE,
    flags.FLAG_FEAT_COACH_OFFERING_REFRESH,
    flags.FLAG_FAMILY_GOLF_REBRAND,
  ])

  return (
    <Router>
      <Switch>
        <Route path="/academy">
          <AcademyRoutes />
        </Route>
        <Route path={FGRActive ? '/family-golf' : '/family-cup'}>
          <FamilyCupRoutes />
        </Route>
        <Route path={FGRActive ? '/family-golf-captain' : '/fc-captain'}>
          <FamilyCupCaptainRoutes />
        </Route>
        <Route
          exact
          path="/pga-coach/bookings/events/new"
          component={CreateEvent}
        />
        <Route exact path="/pga-coach/profile/new" component={CreateProfile} />
        <Route path="/pga-coach">
          <PgaCoachRoutes />
        </Route>
        <Route path="/club">
          <ClubRoutes />
        </Route>
        <Route path="/invitation/:connectionId" component={AcceptInvitation} />
        {isCoachOfferingsRefreshEnabled && (
          <Route exact path="/coach/:idOrSlug/schedule">
            <ThemeProvider theme={extendTheme(themes.offeringsRefresh)}>
              <ScheduleSessionFlow />
            </ThemeProvider>
          </Route>
        )}
        {!isCoachOfferingsRefreshEnabled && (
          <Route
            exact
            path="/coach/:idOrSlug/schedule"
            component={ScheduleSessionFlow}
          />
        )}
        {isLeadIntakeFormEnabled && (
          <Route exact path="/coach/:idOrSlug/schedule/intake-form">
            <ThemeProvider theme={extendTheme(themes.pgaCoach)}>
              <SnackbarProvider
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
              >
                <CoachingRequestForm />
              </SnackbarProvider>
            </ThemeProvider>
          </Route>
        )}
        <Route path={FGRActive ? '/family-golf-signup' : '/fc-signup'}>
          <FamilyCupSignupRoutes />
        </Route>
        {/* TODO: new path for Family Golf */}
        <Route path="/events">
          <FamilyCupMarketingRoutes />
        </Route>
        <Route
          path={
            FGRActive ? '/family-golf-registration' : '/family-cup-registration'
          }
        >
          <FamilyCupRegistrationRoutes />
        </Route>
        <Route
          path={
            FGRActive ? '/family-golf-invitation' : '/family-cup-invitation'
          }
        >
          <FamilyCupInvitationRoutes />
        </Route>
        <Route path="/junior-league">
          <JuniorLeagueRoutes />
        </Route>
        <Route path="/junior-league-events">
          <JuniorLeagueMarketingRoutes />
        </Route>
        <Route path="/junior-league-signup">
          <JuniorLeagueSignupRoutes />
        </Route>
        <Route path="/junior-league-registration">
          <JuniorLeagueRegistrationRoutes />
        </Route>
        <Route path="/junior-league-manager">
          <JuniorLeagueManagerRoutes />
        </Route>
        <Route path="/things-to-do">
          <ThingsToDoRoutes />
        </Route>
        <Route exact path="/booking-confirmation/:confirmationCode">
          <ThemeProvider theme={extendTheme(themes.pgaCoach)}>
            <SnackbarProvider
              anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
              <BookingConfirmationPage />
            </SnackbarProvider>
          </ThemeProvider>
        </Route>
        <Route path="/admin" component={AdminRoutes} />
        <Route path="/account" component={AccountRoutes} />
        <Route exact path="/" component={WelcomePage} />
        <Route exact path="/ab" component={ABTestPage} />
        <Route exact path="/assume-user" component={AssumeUserPage} />
        {isIdeasPageEnabled && <Route exact path="/ideas" component={Ideas} />}
        <Route exact path="/logout" component={LogoutPage} />
        <Route
          exact
          path="/activity-plan/:id"
          component={SinglePlansPublicPage}
        />
        <Route
          exact
          path="/activity-plans"
          component={PublicActivityPlansPage}
        />
        <Route path="/activity-plans/:stage" component={ActivityStage} />
        <Route path="*" render={() => <div>Page Not Found</div>} />
      </Switch>
    </Router>
  )
}

export default Routes
